var AdaptiveImage = require("../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "static/media/recommendation_tick.e404eb0f.png","uri@2x": __webpack_public_path__ + "static/media/recommendation_tick.7f8a0bf3.png","uri@3x": __webpack_public_path__ + "static/media/recommendation_tick.ac6933f4.png",
    width: 5,
    height: 4
});